export default function HeadingDefaultCell({ value }: { value: string }) {
    return (
        <div
            className={` ${!navigator.userAgent.includes("Safari") ? "min-w-max" : "whitespace-nowrap"} min-w-[100px] text-left`}
        >
            {value}
        </div>
    );
}
